import React from 'react';

const Bottom2Shape = ({ className }) => {
  return (
    <svg
      className={className}
      width="271"
      height="444"
      viewBox="0 0 271 444"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M233.68 101.916C-25.7196 -31.5288 -7.25981 84.0187 -7.2597 125.519L-7.25977 385.519C87.1055 354.401 310.741 182.019 233.68 101.916Z"
        fill="white"
      />
    </svg>
  );
};

export default Bottom2Shape;
